import React, { useState, useContext, useRef, useEffect } from "react";
import { GiHamburgerMenu } from "react-icons/gi";
import { MdOutlineRestaurantMenu } from "react-icons/md";
import { FaUserCircle } from "react-icons/fa";
import { FiLogOut } from "react-icons/fi";
import { Link } from "react-router-dom";
import { HashLink } from "react-router-hash-link";
import { AuthContext } from "../../Provider/AuthProvider";

import "./Navbar.css";

const Navbar = () => {
  const [isMobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [isUserMenuOpen, setUserMenuOpen] = useState(false);
  const { user, logout, loading } = useContext(AuthContext);
  const dropdownRef = useRef(null);

  const closeMobileMenu = () => setMobileMenuOpen(false);

  // Close dropdown if clicked outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setUserMenuOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleLogout = () => {
    logout();
    setUserMenuOpen(false);
    closeMobileMenu();
  };

  if (loading) {
    // Render a placeholder instead of Sign In/Profile to avoid flicker
    return (
      <nav className="nav">
        <div className="nav__logo">
          <Link to="/">Wok & Fire</Link>
        </div>
        <ul className="nav__links">
          {/* Optional: spinner or skeleton */}
          <li className="nav__item text-gray-300">Loading...</li>
        </ul>
      </nav>
    );
  }


  return (
    <nav className="nav">
      <div className="nav__logo">
        <Link to="/">Wok & Fire</Link>
      </div>

      {/* Desktop Menu */}
      <ul className="nav__links">
        <li className="nav__item">
          <HashLink smooth to="/#home">Home</HashLink>
        </li>
        <li className="nav__item">
          <HashLink smooth to="/#about">About</HashLink>
        </li>
        <li className="nav__item">
          <HashLink smooth to="/#menu">Menu</HashLink>
        </li>
        <li className="nav__item">
          <HashLink smooth to="/#contact">Contact</HashLink>
        </li>
        <li className="nav__item">
          <Link to="/blog">Blog</Link>
        </li>

        {!user ? (
          <>
            {/* <li className="nav__item">
              <Link to="/login">Sign In</Link>
            </li> */}
            {/* <li className="nav__item">
              <Link to="/signup">Signup</Link>
            </li> */}
          </>
        ) : (
          <li className="nav__item relative" ref={dropdownRef}>
            <button
              className="flex items-center gap-2 text-white hover:text-yellow-400 focus:outline-none"
              onClick={() => setUserMenuOpen(!isUserMenuOpen)}
            >
              <FaUserCircle size={26} />
              {user.name.split(" ")[0]}
            </button>
            {isUserMenuOpen && (
              <div className="absolute right-0 mt-2 w-44 bg-white shadow-lg rounded-lg py-2 z-50">
                <Link
                  to="/profile"
                  onClick={() => setUserMenuOpen(false)}
                >
                  <button
                    className="flex items-center gap-2 w-full px-4 py-2 text-gray-800 hover:bg-red-50 hover:text-red-600 transition"
                  >
                    <FaUserCircle /> Profile
                  </button>
                </Link>
                <button
                  onClick={handleLogout}
                  className="flex items-center gap-2 w-full px-4 py-2 text-gray-800 hover:bg-red-50 hover:text-red-600 transition"
                >
                  <FiLogOut /> Logout
                </button>
              </div>
            )}
          </li>
        )}
      </ul>

      {/* Mobile Menu */}
      <div className="nav__mobile-controls">
        <GiHamburgerMenu
          className="nav__mobile-open"
          onClick={() => setMobileMenuOpen(true)}
        />

        <div className={`nav__mobile-menu ${isMobileMenuOpen ? "active" : ""}`}>
          <MdOutlineRestaurantMenu
            className="nav__mobile-close"
            onClick={closeMobileMenu}
          />
          <ul className="nav__mobile-links">
            <li>
              <HashLink smooth to="/#home" onClick={closeMobileMenu}>Home</HashLink>
            </li>
            <li>
              <HashLink smooth to="/#about" onClick={closeMobileMenu}>About</HashLink>
            </li>
            <li>
              <HashLink smooth to="/#menu" onClick={closeMobileMenu}>Menu</HashLink>
            </li>
            <li>
              <HashLink smooth to="/#contact" onClick={closeMobileMenu}>Contact</HashLink>
            </li>
            <li>
              <Link to="/blog" onClick={closeMobileMenu}>Blog</Link>
            </li>

            {!user ? (
              <>
                <li>
                  <Link to="/login" onClick={closeMobileMenu}>Sign In</Link>
                </li>
                {/* <li>
                  <Link to="/signup" onClick={closeMobileMenu}>Signup</Link>
                </li> */}
              </>
            ) : (
              <>
                <li>
                  <Link to="/profile" className="flex items-center gap-2" onClick={closeMobileMenu}>
                    <FaUserCircle /> Profile
                  </Link>
                </li>
                <li>
                  <button
                    onClick={handleLogout}
                    className="flex items-center gap-2 w-full py-2 text-gray-100 hover:text-red-600 hover:bg-white transition"
                  >
                    <FiLogOut /> Logout
                  </button>
                </li>
              </>
            )}
          </ul>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
